<ng-container *ngIf="!(userIsFromUSAW$ | async); else USAWPasswordForm">
<div class="container form-container" *ngIf="config$ | async as config">
  <div class="row">
    <div
      *ngIf="config.showForgotPasswordForm"
      id="forgot-password-form"
      class="main-area col-sm-6 col-xs-12"
    >
      <h2 class="page-header">Forgot Password</h2>
      <div class="form-wrapper">
        <p class="top-message"
          >Enter your email address, and we'll help you reset your password.</p
        >
        <form
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="sendEmail()"
          novalidate
        >
          <div class="form-group">
            <input
              floAnalytics
              type="email"
              formControlName="email"
              name="Email"
              placeholder="Enter your email address"
              (focus)="email?.markAsUntouched()"
              [events]="['click', 'focus']"
              autocomplete="off"
              maxlength="76"
            />
            <div
              class="spinner-border spinner-border-sm primary-color-text"
              role="status"
              *ngIf="showEmailSpinner$ | async"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
            <flo-form-errors
              *ngIf="showFormErrorComponent()"
              [errors]="email?.errors"
              control="forgotPassEmail"
            ></flo-form-errors>
            <flo-claim-account-error
              *ngIf="email?.hasError('unclaimed_account')"
              [migratedSite]="email?.errors?.unclaimed_account?.customText"
              [email]="email?.value"
            ></flo-claim-account-error>
          </div>
          <div class="form-button">
            <button
              floAnalytics
              type="submit"
              class="btn btn-primary btn-lg"
              [disabled]="!canSubmitForgotPassword"
              name="Send Forgot Password Email"
              >Submit</button
            >
            <div
              class="spinner-border spinner-border-sm"
              role="status"
              *ngIf="forgotPasswordSubmitting"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div
      *ngIf="config.showForgotPasswordSuccess"
      id="forgot-password-success"
      class="main-area col-sm-6 col-xs-12"
    >
      <h2 class="page-header">Check your inbox.</h2>
      <div class="form-wrapper">
        <p class="top-message"
          >We emailed you a special link so you can reset your password.</p
        >
        <div class="form-button">
          <button
            floAnalytics
            class="btn btn-primary btn-lg"
            name="Go Home"
            routerLink
            >Got It</button
          >
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="config.showResetPasswordForm"
    id="reset-password-form"
    class="main-area col-sm-6 col-xs-12"
  >
    <h2 class="page-header">Reset Password</h2>
    <div class="form-wrapper">
      <p class="top-message"
        >This will reset your password across all FloSports websites.</p
      >
      <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="resetPassword()"
        novalidate
      >
        <div class="form-group">
          <input
            floAnalytics
            type="password"
            formControlName="password"
            name="Password"
            placeholder="Reset password"
            (focus)="password?.markAsUntouched()"
            [events]="['click', 'focus']"
            autocomplete="off"
            maxlength="126"
          />
          <flo-form-errors
            *ngIf="password?.touched && password?.invalid"
            [errors]="password?.errors"
            control="resetPassword"
          ></flo-form-errors>
        </div>
        <div class="form-group">
          <input
            floAnalytics
            type="password"
            formControlName="confirm_password"
            name="Confirm Password"
            placeholder="Re-enter password"
            (focus)="confirmPassword?.markAsUntouched()"
            [events]="['click', 'focus']"
            autocomplete="off"
            maxlength="126"
          />
          <flo-form-errors
            *ngIf="confirmPassword?.touched && confirmPassword?.invalid"
            [errors]="confirmPassword?.errors"
            control="confirmPassword"
          ></flo-form-errors>
          <div
            class="error-box"
            *ngIf="
              resetPasswordForm.hasError('password_mismatch') &&
              confirmPassword?.touched
            "
          >
            <p floAnalytics class="error-msg">Passwords must match</p>
          </div>
          <div
            class="error-box"
            *ngIf="
              resetPasswordForm.hasError('serverError') &&
              confirmPassword?.touched
            "
          >
            <p floAnalytics class="error-msg">{{ resetPasswordForm.errors?.serverError }}</p>
          </div>
        </div>
        <div class="form-button">
          <button
            floAnalytics
            type="submit"
            class="btn btn-primary btn-lg"
            [disabled]="!canSubmitResetPassword"
            name="Set New Password"
            >Submit</button
          >
          <div
            class="spinner-border spinner-border-sm"
            role="status"
            *ngIf="resetPasswordSubmitting"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div
    *ngIf="config.showTokenExpired"
    id="token-expired"
    class="main-area col-sm-6 col-xs-12"
  >
    <h2 class="page-header expired-link">Your link expired</h2>
    <div class="form-wrapper">
      <p class="top-message"
        >To reset your password, please request a new link.</p
      >
      <div class="form-button">
        <button
          floAnalytics
          class="btn btn-primary btn-lg"
          [routerLink]="['../../forgot-password']"
          routerLinkActive="active"
          name="Request New Reset Password Link"
          >Request New Link</button
        >
      </div>
    </div>
  </div>
  <div
    *ngIf="config.showResetPasswordSuccess"
    id="reset-password-success"
    class="main-area col-sm-6 col-xs-12"
  >
    <h2 class="page-header">Success!</h2>
    <div class="form-wrapper">
      <p class="top-message"
        >You can now use your new password to log in to all FloSports sites.</p
      >
      <div class="form-button">
        <button
          floAnalytics
          class="btn btn-primary btn-lg"
          name="Go To Login"
          routerLink="/login"
          >Go To Login</button
        >
      </div>
    </div>
  </div>
  <div class="row">
    <div class="support-text">
      Having trouble logging in? Contact<a
        floAnalytics
        name="Customer Support Contact Form"
        href="https://support.flosports.tv/"
      >
        Customer Support</a
      >
    </div>
  </div>
</div>
</ng-container>

<!-- USAW Reset Password -->
<ng-template #USAWPasswordForm>
<div class="container form-container usaw-form" *ngIf="config$ | async as config">
  <div class="funnel-form-wrapper" id="usaw-password-form">
    <div class="funnel-form-section" *ngIf="config.showResetPasswordForm">
        <div class="title-section mb-3">
          <h1 class="funnel-title header">Welcome</h1>
        </div>
        <div class="mb-2">
          <p class="subheader">
            Thank you for signing up for FloWrestling.
            To continue please enter a new password.
          </p>
        </div>
        <form [formGroup]="resetUSAWPasswordForm" (ngSubmit)="resetPassword()">
          <div class="form-group">
            <div class="form-password">
              <input
                floAnalytics
                (focus)="password?.markAsUntouched()"
                [events]="['click', 'focus']"
                name="Password"
                formControlName="USAW_password"
                placeholder="Password"
                data-test="USAW-password"
                autocomplete="off"
                maxlength="126"
                class="form-control-lg"
                [type]="showResetUSAWPassword ? 'text' : 'password'"
              />
              <div class="form-password-icon" (click)="toggleShowUSAWPassword($event)">
                <ng-container *ngIf="showResetUSAWPassword; else hidePassword">
                  <flo-svg-icon class="show-password-icon" data-test="form-show-password-icon" icon="show-password" height="1.5rem" width="1.5rem"></flo-svg-icon>
                </ng-container>
                <ng-template #hidePassword>
                  <flo-svg-icon class="hide-password-icon" data-test="form-hide-password-icon" icon="hide-password" height="1.5rem" width="1.5rem"></flo-svg-icon>
                </ng-template>
              </div>
            </div>
            <flo-form-errors
            *ngIf="USAWPassword?.touched && USAWPassword?.invalid"
            [errors]="USAWPassword?.errors"
            control="resetPassword"
            [hasIcon]="false"
            ></flo-form-errors>
          </div>
          <div class="form-button mb-4">
            <button
              floAnalytics
              events="click"
              name="Continue"
              type="submit"
              class="btn btn-primary btn-lg lg-font-btn w-100"
              data-test="continue-button"
              [disabled]="!canSubmitResetUSAWPassword"
            >
              Continue
            </button>
            <div
              class="spinner-border spinner-border-sm"
              role="status"
              *ngIf="resetUSAWPasswordSubmitting"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
        <div class="customer-support-prompt funnel-form-footnotes">
          <p class="funnel-form-footnote flo-footnote"
            >Having trouble setting up a password?<br> Contact
            <a
              floAnalytics
              href="https://support.flosports.tv/"
              target="_blank"
              queryParamsHandling="merge"
              routerLinkActive="active"
              class="text-900 text-decoration-underline hover-grey-500"
              name="Go To Customer Support"
              >Customer Support</a
            >.</p
          >
        </div>
    </div>
      <div
        *ngIf="config.showResetPasswordSuccess"
        id="reset-usaw-password-success"
        class="funnel-form-section"
      >
      <h2 class="funnel-title header mb-3">Success!</h2>
      <div class="form-wrapper">
        <p class="subheader mb-3"
          >You can now use your new password to log in to all FloSports sites.</p
        >
        <div class="mb-4">
          <button
            floAnalytics
            class="btn btn-primary btn-lg lg-font-btn w-100"
            name="Go To Login"
            routerLink="/login"
            >Go To Login</button
          >
        </div>
      </div>
      <div class="row">
        <div class="customer-support-prompt funnel-form-footnotes">
          <p class="funnel-form-footnote flo-footnote">
            Having trouble logging in?<br> Contact <a
            floAnalytics
            name="Customer Support Contact Form"
            href="https://support.flosports.tv/"
            target="_blank"
            class="text-900 text-decoration-underline hover-grey-500"
          >
            Customer Support</a
          >.</p>
        </div>
      </div>
    </div>
  </div>
</div>
</ng-template>
